import { useEffect, useState } from 'react';

import styled from '@emotion/styled';
import { Divider } from '@kc-console/common-ui';

import { useMegaMenuState } from '../../../../hooks';
import { ALL_CATEGORY } from '../../../../stores/useMegaMenuStore';
import AllServiceContent from './AllServiceContent';
import CategoryContent from './CategoryContent';
import SearchInput from './SearchInput';
import SearchResults from './SearchResults';

const Content = () => {
  const [inputValue, setInputValue] = useState('');
  const { isAllCategory, isOpen, setActiveCategory } = useMegaMenuState();

  // 메가메뉴가 닫힐 때 검색어와 카테고리 초기화
  useEffect(() => {
    if (!isOpen) {
      setInputValue('');
      setActiveCategory(ALL_CATEGORY);
    }
  }, [isOpen, setActiveCategory]);

  return (
    <ContentWrapper>
      <SearchInput inputValue={inputValue} setInputValue={setInputValue} />
      <Divider margin={12} />
      {inputValue ? (
        <SearchResults inputValue={inputValue} />
      ) : isAllCategory ? (
        <AllServiceContent />
      ) : (
        <CategoryContent />
      )}
    </ContentWrapper>
  );
};

const ContentWrapper = styled.main`
  flex: 1 1;
  min-width: 0;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
`;

export default Content;
